import React, { Component } from "react";
import ContentBody from "../components/ContentBody";
import ArticleList from "../components/ArticleList";
import PageHeader from "../components/PageHeader";
import Language from "../utils/Language";

class PageGames extends Component {
  render() {
    return (
      <ContentBody>
        <PageHeader
          eyebrow={Language.GetString("games_page_eyebrow")}
          title={Language.GetString("games_page_title")}
          subtitle={Language.GetString("games_page_subtitle")}
        />
        <ArticleList articles={require("../products/games.json")} />
      </ContentBody>
    );
  }
}

export default PageGames;
